import React, { useEffect, useState } from "react";
import "./number-pair.css";
import { Alert, Flex } from "antd";
import Confetti from "react-confetti";

const LIMIT = 5;

export default function NumberPressGamePage() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const generateNumbers = () => {
    const numbers: number[] = [];
    for (let i = 1; i <= LIMIT; i++) {
      numbers.push(i);
    }
    return numbers.sort(() => Math.random() - 0.5);
  };

  const [questions, setQuestions] = useState<number[]>(generateNumbers());
  const [answers, setAnswers] = useState<number[]>(generateNumbers());

  const [selectedQuestion, setSelectedQuestion] = useState<number>();
  const [selectedAnswer, setSelectedAnswer] = useState<number>();

  const handleAnswerClick = (ans: number) => {
    setSelectedAnswer(ans);

    if (ans === selectedQuestion) {
      const qIndex = questions.indexOf(ans);
      const aIndex = answers.indexOf(ans);
      const audio = new Audio("/assets/audio/beep.mp3");
      audio.play();

      setTimeout(() => {
        if (qIndex !== -1 && aIndex !== -1) {
          // Create new arrays instead of mutating in place
          const newQuestions = questions.filter((_, idx) => idx !== qIndex);
          const newAnswers = answers.filter((_, idx) => idx !== aIndex);
          setQuestions(newQuestions);
          setAnswers(newAnswers);
        }
        setSelectedQuestion(undefined);
      }, 500);
    }
  };

  useEffect(() => {
    if (questions.length === 0) {
      triggerConfetti();
    }
  }, [questions]);

  const handleQuestionClick = (num: number) => {
    setSelectedQuestion(num);
  };
  const [showConfetti, setShowConfetti] = useState(false);

  const triggerConfetti = () => {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 3000); // stops after 3 seconds
  };

  return (
    <div style={{ height: 1200 }}>
      <div className="center-align my-40">
        <h3>Number Pairs</h3>
      </div>

      {showConfetti && (
        <Confetti width={windowSize.width} height={windowSize.height} />
      )}

      {questions.length === 0 && (
        <div className="p-40">
          <Alert
            message="Game Complete"
            description="Congratulations"
            type="success"
            showIcon
          />
        </div>
      )}

      <Flex gap={"30%"} className="center-align ">
        <Flex vertical gap={20}>
          {questions.map((q) => (
            <div
              id={`q${q}`}
              key={q}
              className={`tile ${selectedQuestion === q ? "selected" : ""}`}
              onClick={() => handleQuestionClick(q)}
            >
              {q}
            </div>
          ))}
        </Flex>

        <Flex vertical gap={20}>
          {answers.map((q) => (
            <div
              key={q}
              className={`tile ${selectedAnswer === q ? "selected" : ""}`}
              onClick={() => handleAnswerClick(q)}
            >
              {q}
            </div>
          ))}
        </Flex>
      </Flex>
    </div>
  );
}
